import axios from 'axios'

export default {
  getAxiosInstance (host) {
    return axios.create({baseURL: host})
  }
}



// WEBPACK FOOTER //
// ./src/services/api/http.js